import * as React from "react";
import clsx from "clsx";
import { CloseButton } from "../../close-button/close-button.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
const Toast = React.forwardRef(function Toast2({ children, type = "info", onClose, className, timeoutAnimationState = "running", ...rest }, ref) {
  const handleCloseClick = React.useCallback(
    (event) => {
      if (onClose) {
        onClose(event);
      }
    },
    [onClose]
  );
  return /* @__PURE__ */ React.createElement("div", { ref, className: clsx("toast", "toast--".concat(type), className), ...rest }, /* @__PURE__ */ React.createElement(Icon, { modifiers: iconMap[type], className: "toast__icon" }), /* @__PURE__ */ React.createElement("div", { className: "toast__content" }, children), /* @__PURE__ */ React.createElement("div", { className: "toast__close-button-wrapper" }, /* @__PURE__ */ React.createElement(CloseButton, { className: "toast__close-button", onClick: handleCloseClick, attributes: { tabIndex: -1, "aria-hidden": true } }), /* @__PURE__ */ React.createElement("svg", { className: "toast__close-button-circle", viewBox: "0 0 40 40", focusable: "false" }, /* @__PURE__ */ React.createElement("circle", { className: "toast__close-button-circle-shadow", cx: "20", cy: "20", r: "16", fill: "none" }), /* @__PURE__ */ React.createElement("circle", { className: "toast__close-button-circle-path", cx: "20", cy: "20", r: "16", fill: "none", style: { animationPlayState: timeoutAnimationState } }))));
});
const iconMap = {
  info: "#info-round-filled",
  error: "#alert-filled",
  success: "#check-round-filled",
  attention: "#alert-round-filled"
};
export {
  Toast
};
